/* eslint no-console: off */

import Mitt from 'mitt';
import appConfig from 'src/utils/appConfig';

window.SHOULD_LOG_EVENTS = appConfig.getMyConfig().environment === 'test';

export default class EventEmitter {
  constructor({ type, color = '#FF790F' }) {
    this.type = type;
    this.color = color;
    const eventEmitter = Mitt();
    this.on = eventEmitter.on;
    this.off = eventEmitter.off;
    this.emit = eventEmitter.emit;
    this.logEvent = this.logEvent.bind(this);
    this.on('*', this.logEvent);
  }

  logEvent(eventName, payload) {
    if (window.SHOULD_LOG_EVENTS) {
      const title = `${this.type} Event`;
      const subtitle = `${this.constructor.name}:${eventName}`;
      console.groupCollapsed(
        `%c${title}%c ${subtitle}`,
        `font-weight:100; color: ${this.color}`,
        'font-weight:800;'
      );
      console.log('payload:', payload);
      console.groupEnd();
    }
  }
}
